/**
 * abLeg.js
 * Written by: Alex Kasemir
 */

import extraActions from 'store/extra/actions';

/**
 * Description of the abLeg reducer
 */
const abLeg = (state = {}, action) => {
  switch (action.type) {
    case extraActions.SET_AB_LEG_SUCCESS:
      return {
        ...state,
        [action.test]: action.leg,
      };
    default:
      return state;
  }
};

export default abLeg;
